
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/exclusive-offers",
      function () {
        return require("private-next-pages/exclusive-offers/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/exclusive-offers"])
      });
    }
  